import { render, staticRenderFns } from "./VSelectSede.vue?vue&type=template&id=5c05798e"
import script from "./VSelectSede.vue?vue&type=script&lang=js"
export * from "./VSelectSede.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports